const storageUrl = process.env.FILES_STORAGE_URL || 'https://disk.2gis.com';
const bucketName = process.env.AWS_S3_BUCKET_NAME;

/**
 * Формирует прямой URL к публичному S3-ресурсу.
 *
 * Используйте этот helper, когда точно нужен public storage без imgproxy.
 * Для новых задач с media-ресурсами сначала проверьте `generateResourceUrl`:
 * он сам выбирает imgproxy для images и public storage для gif/video.
 *
 * @param contentPath - Bucket-relative путь к ресурсу без начального слэша.
 * @returns Публичный URL ресурса в файловом storage.
 */
export const generatePublicContentUrl = (contentPath: string) =>
  `${storageUrl}/${bucketName}/${contentPath}`;
